import { render, staticRenderFns } from "./DatasetImagePicker.vue?vue&type=template&id=3f163253&scoped=true"
import script from "./DatasetImagePicker.vue?vue&type=script&lang=js"
export * from "./DatasetImagePicker.vue?vue&type=script&lang=js"
import style0 from "./DatasetImagePicker.vue?vue&type=style&index=0&id=3f163253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f163253",
  null
  
)

export default component.exports